import { Component } from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"

import exitIcon from "images/icons/icon-x.svg?raw"
import searchIcon from "images/web/browse/search.svg?raw"

export default class SearchInput extends Component {
  constructor(props) {
    super(props)
    this.autoFocusTimeoutId = null
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.autoFocusTimeoutId = setTimeout(() => this.focus(), 0)
    }
  }

  componentWillUnmount() {
    if (this.autoFocusTimeoutId != null) {
      clearTimeout(this.autoFocusTimeoutId)
    }
  }

  focus() {
    this.textinputRef?.focus()
  }

  render() {
    return (
      <div className="ifttt-search">
        <input
          id={this.props.wrapperId}
          className="ifttt-search-input"
          type="text"
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          value={this.props.value}
          onClick={this.props.onClick}
          onBlur={this.props.onBlur}
          onKeyDown={this.props.onKeyDown}
          maxLength={this.props.maxLength}
          autoComplete={this.props.autoComplete}
          ref={r => (this.textinputRef = r)}
          spellCheck={false}
          aria-label={this.props.inputID}
        />
        <span className="icon search">
          {parse(searchIcon)}
        </span>
        {this.props.showCloseIcon && (
          <span className="icon clean-search" onClick={this.props.onXClick}>
            {parse(exitIcon)}
          </span>
        )}
      </div>
    )
  }
}

SearchInput.propTypes = {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  inputID: PropTypes.string,
  maxLength: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onXClick: PropTypes.func,
  placeholder: PropTypes.string,
  showCloseIcon: PropTypes.bool,
  value: PropTypes.string,
  wrapperId: PropTypes.string,
}

SearchInput.defaultProps = {
  autoComplete: "off",
  autoFocus: true,
  inputID: "search",
  maxLength: "1024",
  placeholder: "Search",
  showCloseIcon: true,
  value: "",
}
